import FAQArticle from "./FAQArticle";

export default class FAQSearchResult {
    public numberOfTotalResults : number = 0;
    public results : FAQArticle[] = [];
}